import { render, staticRenderFns } from "./pages-modal.vue?vue&type=template&id=25ff5fd0&scoped=true"
import script from "./pages-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./pages-modal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff5fd0",
  null
  
)

export default component.exports